module.exports = __webpack_public_path__ + "img/search-module.49da42e3.svg";